import { render, staticRenderFns } from "./SidebarPermohonanTanggalAkhir.vue?vue&type=template&id=d17d09e0&"
import script from "./SidebarPermohonanTanggalAkhir.vue?vue&type=script&lang=js&"
export * from "./SidebarPermohonanTanggalAkhir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports